import i18n from 'i18next';
import { workoutDisplayDigits as displayDigits } from './workoutNumberFormat';
import { normalizeInputDigits } from './localizedInput';

/** Translate known builder labels only; preserve user-authored workout names. */
export function localizeWorkoutBuilderText(value: string): string {
  const language = i18n.resolvedLanguage ?? i18n.language ?? 'en';
  const labels = (i18n.getResource(language, 'translation', 'workoutBuilder.textLabels')
    ?? i18n.getResource(language.split('-')[0], 'translation', 'workoutBuilder.textLabels')) as Record<string, string> | undefined;
  if (labels && typeof labels === 'object' && labels.minuteUnit === 'دقیقه') {
    const interval = normalizeInputDigits(value).trim().match(/^(\d+)x(\d+)min$/);
    if (interval) return displayDigits(`${interval[1]} × ${interval[2]} ${labels.minuteUnit}`);
    if (/^Zone\s+[\d–% -]+$/.test(normalizeInputDigits(value))) return displayDigits(value.replace(/^Zone/, labels.Zone));
  }
  if (labels && Object.prototype.hasOwnProperty.call(labels, value)) return displayDigits(labels[value]);
  const stepKeys: Record<string, string> = { Hard: 'hard', Interval: 'interval' };
  return displayDigits(Object.prototype.hasOwnProperty.call(stepKeys, value)
    ? i18n.t(`workoutBuilder.stepNames.${stepKeys[value]}`) : value);
}

export function localizeWorkoutIntensity(value: string): string {
  return displayDigits(value.replace(/% Max HR|% LTHR|% Speed|% FTP|\bbpm\b|\bW\b|\/km/g, localizeWorkoutBuilderText));
}

/** Translate imported default sport titles without rewriting athletes' custom names. */
export function localizeWorkoutTitle(value: string): string {
  const sportKeys: Record<string, string> = {
    'road cycling': 'bike', cycling: 'bike', bike: 'bike',
    run: 'run', running: 'run', swim: 'swim', swimming: 'swim',
    strength: 'strength', 'strength training': 'strength',
  };
  const key = value.trim().toLowerCase();
  if (Object.prototype.hasOwnProperty.call(sportKeys, key)) return displayDigits(i18n.t(`sportDuration.sports.${sportKeys[key]}`));
  if (key === 'rest' || key === 'day off') return localizeWorkoutBuilderText('Rest');
  return localizeWorkoutBuilderText(value);
}
